import Vue from 'vue'
import Axios from 'axios'

export default {//经常调用的接口
    getDone ({ state, commit }) { //暑假作业完成提交
        return new Promise((resolve, reject) => {
            Axios.post(API_URL_HD_API + '/summer2019/stu/done/', {
                "type": 2 // 1 亲子阅读 2 复习试题 3自学拓展
            }).then(res => {
                resolve();
            })
        })
    },
    confirmAdd ({
        state,
        commit
    }, _data) {
        return new Promise((resolve, reject) => {
            Axios.post(API_URL_TASK_API + '/public/task/stu/confirm/add', _data).then(res => {
                resolve();
            })
        })
    },
    wrong_Statistics ({ state, commit }, _type) {  //埋点
        // 1 数学小题详情页视频开通按钮
        // 2 查看错题解析按钮
        // 3 立即订购按钮
        return new Promise((resolve, reject) => {
            Axios.post(API_URL_HD_API + '/wrong_question_clear/statistics/ ', { "type": _type }).then(res => {
                resolve();
            })
        })
    },
    urge_content ({
        state,
        commit
    }, _obj) { //短信内容
        console.log(_obj)
        //  type 1 催促未做完 2 催促个性化学习 3 催促错题订正
        return new Promise((resolve, reject) => {
            Axios.post(API_URL_TASK_API + '/public/task/urge/content ', _obj).then(res => {
                resolve(res);
            })
        })
    },
}
